import {
    useMemo,
} from 'react'
import {
    useOutlet, useNavigate, useParams,
    useLocation, Outlet, useResolvedPath,
} from 'react-router-dom'

export default function useDetailedViewOutlet() {
    const location = useLocation()

    const {
        pathname,
    } = useResolvedPath('..')

    const navigate = useNavigate()
    const outlet = useOutlet()
    const {
        key,
    } = useParams()

    return useMemo(() => {
        return {
            id: key,
            isDetailsView: Boolean(key) || Boolean(outlet),
            locationPathname: location.pathname,
            tablePath: pathname,
            navigate,
            Outlet,
            activeTabName: location.pathname
                .replace(pathname, '')
                .split('/')
                .filter(Boolean)
                .at(0),
        }
    }, [
        key,
        location.pathname,
        navigate,
        outlet,
        pathname,
    ])
}
